module.exports = __webpack_public_path__ + "img/room-no-photo.0d27d91f.svg";